import { useHealth } from '../hooks/useHealth'

export function Header() {
  const health = useHealth()

  const badge = {
    ok: { text: 'API Online', className: 'bg-emerald-500/20 text-emerald-400 border border-emerald-500/30' },
    error: { text: 'API Offline', className: 'bg-red-500/20 text-red-400 border border-red-500/30' },
    loading: { text: 'Checking...', className: 'bg-gray-500/20 text-gray-400 border border-gray-500/30' },
  }[health]

  return (
    <header className="border-b border-ev-border bg-ev-card/80 backdrop-blur-sm">
      <div className="mx-auto flex max-w-[1600px] items-center justify-between px-4 py-3 sm:px-6 sm:py-4">
        <div className="flex items-center gap-2.5 sm:gap-3">
          <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-gradient-to-br from-ev-accent to-ev-blue text-xs font-bold text-white sm:h-9 sm:w-9 sm:text-sm">
            OQ
          </div>
          <div>
            <h1 className="text-base font-bold tracking-tight text-white sm:text-lg">
              OptiQuant<span className="text-ev-accent">-EV</span>
            </h1>
            <p className="hidden text-[11px] text-gray-500 sm:block">Quantitative Options · EV Scanner</p>
          </div>
        </div>

        <div className="flex items-center gap-2.5 sm:gap-4">
          <div className="hidden text-right text-xs text-gray-500 sm:block">
            <span className="font-mono">BTCUSDT</span> · Real-time
          </div>
          <span className={`badge text-[9px] sm:text-[10px] ${badge.className}`}>
            <span className={`mr-1 h-1.5 w-1.5 rounded-full sm:mr-1.5 ${health === 'ok' ? 'bg-emerald-400 animate-pulse' : health === 'error' ? 'bg-red-400' : 'bg-gray-400'}`} />
            {badge.text}
          </span>
        </div>
      </div>
    </header>
  )
}
